import { observer } from "mobx-react-lite";

import { useNewPartnerFormState } from "./form.state";
import { NewPartnerFormView } from "./form.view";

export const NewPartnerForm = observer(() => {
  const state = useNewPartnerFormState();
  return <NewPartnerFormView state={state} />;
});
